exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-import .import-header-name[data-v-9d2b60e2]{flex-shrink:0}", ""]);

// exports
